import { isNull } from 'lodash';
import { activeBadge } from 'themes/colors';

export const getContactLabel = contact => (
  `${contact.first_name} ${isNull(contact.last_name) ? '' : contact.last_name} (${contact.email})`
);

export const getContactFullName = contact => (
  `${contact.first_name} ${isNull(contact.last_name) ? '' : contact.last_name}`
);

export const getOutletNameUrl = outlet => (
  `${outlet.name} ${isNull(outlet.website) ? '' : outlet.website}`
);

export const STATUS_BADGE_LABEL = {
  active: 'Active',
  confirmed: 'Confirmed',
  published: 'Published',
  not_now: 'Not Now',
  closed: 'Closed',
};

export const STATUS_BADGE_COLORS = {
  active: activeBadge,
  confirmed: activeBadge,
  published: activeBadge,
  not_now: activeBadge,
  closed: activeBadge,
};

export const OPPORTUNITY_STAGES = {
  active: 'active',
  confirmed: 'confirmed',
  published: 'published',
  not_now: 'not_now',
  closed: 'closed',
};

export const STAGE_OPTIONS = [
  { label: 'Active', value: OPPORTUNITY_STAGES.active },
  { label: 'Confirmed', value: OPPORTUNITY_STAGES.confirmed },
  { label: 'Published', value: OPPORTUNITY_STAGES.published },
  { label: 'Not Now', value: OPPORTUNITY_STAGES.not_now },
  { label: 'Closed', value: OPPORTUNITY_STAGES.closed },
];

export const STATUS_CHANGEABLE = STAGE_OPTIONS.map(option => option.label.toLowerCase());
